import MidiEffect from './MidiEffect.js';
import {isNumber} from 'utils/IsNumber.js';
import {AbstractParameter} from 'parameters/AbstractParameter.js';

export default class MicroTuningEffect extends MidiEffect {
    constructor(track) {
        super('Micro Tuning', track);

        // a mapping between transpose number and
        // transpose offset
        // When user plays note "+4", it first gets
        // thrown into the algo func. (4) => 4
        // And then whatever value is in offsets[4] gets
        // added to this
        this.scriptParameter = new AbstractParameter(
            'script',
            this, (o, x) => this.executeScript(x),
            {
                defaultValue: "(x) => x"
            });
            
        this.offsets = {};

        // identity algo (i.e. equal tempermant)
        // could do x/3 to do non-equal temperament
        this.algo = (x) => x;
    }

    executeScript(script, isTest=false) {
        try {
            let algo = eval(script);
            if (isNumber(algo(5))) {
                if (!isTest) {
                    this.algo = algo;
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }

    newNoteOffset(note, offset=0) {
        let parameter = new AbstractParameter(
            "noteOffset",
            this,
            () => [],
            {
                defaultValue: offset,
                min: -1,
                max: 1
            });

        this.registerParameter(parameter);
        if (this.context) {
            parameter.setContext(this.context);
        }
        this.offsets[note] = parameter;
        return parameter;
    }

    output() {
        for (let i in this.triggers) {
            let duration = this.triggers[i].stepData.duration;
            let transpose = this.getTranspose(this.triggers[i].stepData.transpose);
            let stepData = this.getStep(
                this.triggers[i].stepData,
                transpose, 
                this.triggers[i].stepData.duration,
                false);

            stepData.duration = duration === null ? undefined : duration;
            this.triggers[i].stepData = stepData;
        }

        return this.triggers;
    }

    getTranspose(transpose) {
        let rounded = Math.round(transpose);

        let offset = rounded in this.offsets ?
            this.offsets[rounded].get() : 0;

        let ret =  this.algo(transpose) + offset;
        return Math.max(Math.min(42, ret), -42);
    }

    getJson(isPreset) {
        let offsets = {};
        for (let note in this.offsets) {
            offsets[note] = this.offsets[note].get();
        }
        return {
            ... super.getJson(isPreset),
            script: this.scriptParameter.get(),
            offsets
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);

        for (let note in json.offsets) {
            this.newNoteOffset(parseFloat(note), json.offsets[note]);
        }

        this.scriptParameter.set(json.script);
    }

    getCopy(track, ignoreId=true) {
        let effect  = new MicroTuningEffect(track);
        effect.fromJson(this.getJson(), ignoreId);
        return effect;
    }
}
